import { render } from "./Overview.vue?vue&type=template&id=a97be5b2&scoped=true&bindings={}"
import script from "./Overview.vue?vue&type=script&lang=ts"
export * from "./Overview.vue?vue&type=script&lang=ts"

import "./Overview.vue?vue&type=style&index=0&id=a97be5b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a97be5b2"

export default script